/**
 * Translate description: Table component
 */

import { Fragment, useContext } from 'react';

import { useLanguageContext } from "../../../context/LanguageContext";
import AppContext from '../../../context/AppContext';

import Filter from '../../../components/filter/Filter';
import FilterSourceLang from '../../../components/filter/FilterSourceLang';
import FilterTranslated from '../../../components/filter/FilterTranslated';
import FilterStatus from '../../../components/filter/FilterStatus';
import Chip from '@mui/joy/Chip';

import {
  ContentTable, ContentHeader, ContentHeaderItem, ContentBody,
  ContentBodyCheckbox, ContentBodyItem,
  ContentBodyItemImage, ContentBodyItemStatus, ContentBodyItemStatusCPA,
  ContentBodyItemTranslations, ContentBodyItemEdit
} from '../../../components/blocks/ContentTable';

import { ContentList, ContentListRow, ContentListItem } from '../../../components/blocks/ContentList';

export default function Content() {
  const { t } = useLanguageContext();
  const { listItems } = useContext(AppContext);
  const { loading } = useContext(AppContext);

  return (
    <Fragment>
      <Filter fields={['name']}>
        <FilterSourceLang />
        <FilterTranslated />
        <FilterStatus />
      </Filter>

      <ContentTable>
        <ContentHeader>
          <ContentHeaderItem title={t('ID')} sortBy="id" width={50} />
          <ContentHeaderItem title={t('Image')} width={100} />
          <ContentHeaderItem title={t('Name')} sortBy="name" />
          <ContentHeaderItem title={t('Translations')} width={120} />
          <ContentHeaderItem title={t('Creator')} width={100} />
          <ContentHeaderItem title={t('Status')} width={100} />
          <ContentHeaderItem title={t('Status CPA')} width={100} />
          <ContentHeaderItem title={t('Offers')} width={100} />
          <ContentHeaderItem width={100}></ContentHeaderItem>
        </ContentHeader>

        <ContentBody colspan={11}>
          {(Array.isArray(listItems) && !loading && listItems?.length) ? (
            listItems.map((row) => (
              <tr key={row.id}>
                <ContentBodyCheckbox row={row} />
                <ContentBodyItem>{row.id}</ContentBodyItem>
                <ContentBodyItemImage image={row.logo} />
                <ContentBodyItem to={`/store/${row.id}`}>{row.name}</ContentBodyItem>
                <ContentBodyItemTranslations row={row} editLink="store" />
                <ContentBodyItem>{row.creator?.name ?? row.creator?.login ?? ''}</ContentBodyItem>
                <ContentBodyItemStatus row={row} />
                <ContentBodyItemStatusCPA row={row} />
                <ContentBodyItem>
                  {!row.offcnt && '...'}
                  {!!row.offcnt?.active && <Chip color="success">{row.offcnt.active}</Chip>}
                  {!!row.offcnt?.inactive && !!row.offcnt?.active && '/'}
                  {!!row.offcnt?.inactive && <Chip color="danger">{row.offcnt.inactive}</Chip>}
                </ContentBodyItem>
                <ContentBodyItemEdit row={row} addLink='stores' editLink='store' deleteLink='stores' />
              </tr>
            ))
          ) : null}
        </ContentBody>
      </ContentTable>

      <ContentList>
        {(Array.isArray(listItems) && !loading && listItems?.length) ? (
          listItems.map((row) => (
            <ContentListRow key={row.id} row={row} editLink={'store'} deleteLink={'stores'}>
              <ContentListItem>{row.name}</ContentListItem>
              <ContentListItem>{row.slug}</ContentListItem>
            </ContentListRow>
          ))
        ) : null}
      </ContentList>

    </Fragment >
  );
}